<div class="page-size-section">
  <select id="{{idString}}-select" (change)="onPageSizeChanged()" *ngIf="selectedPageSizeValue && !hidePageSizeSelector"
    [(ngModel)]="selectedPageSizeValue" class="form-select form-select-sm">
    <option *ngFor="let size of paginationPageSizes">
      {{size}}
    </option>
  </select>
</div>
<div class="ag-paging-panel ag-unselectable">
  <span class="ag-paging-row-summary-panel" *ngIf="startIndex !== 'undefined' && endIndex !== 'undefined'">
    <span class="number">{{startIndex}}</span> to <span class="number">{{endIndex}}</span> of <span
      class="number">{{totalRecordsCount}}</span>
  </span>

  <span class="ag-paging-page-summary-panel" *ngIf="currentPage !== 'undefined' && totalPages !== 'undefined'">
    <div ref="btFirst" class="ag-paging-button" [ngClass]="{'ag-disabled': (currentPage < 2) }"
      (click)="firstPageClick()">
      <span class="ag-icon ag-icon-first"></span>
      <button type="button">First</button>
    </div>

    <div ref="btPrevious" class="ag-paging-button" [ngClass]="{'ag-disabled': currentPage <2 }"
      (click)="prevPageClick()">
      <span class="ag-icon ag-icon-previous"></span>
      <button type="button">Previous</button>
    </div>

    Page <span class="number">{{currentPage}}</span> of <span class="number">{{totalPages}}</span>

    <div ref="btNext" class="ag-paging-button" [ngClass]="{'ag-disabled': currentPage===totalPages }"
      (click)="nextPageClick()">
      <span class="ag-icon ag-icon-next"></span>
      <button type="button">Next</button>
    </div>

    <div ref="btLast" class="ag-paging-button" [ngClass]="{'ag-disabled': currentPage===totalPages }"
      (click)="lastPageClick()">
      <span class="ag-icon ag-icon-last"></span>
      <button type="button">Last</button>
    </div>
  </span>
</div>